/**
 * User: nir
 * Date: 05/09/2016
 * Time: 13:24
 */

if (window.jQuery) {
// Social Icons //
    jQuery(function ($) {
        var social = $('ul[data-action="update-social"]');
        var articleContent = $('section[data-type="article-content"]');

        if (social.length !== 0 && articleContent !== 0) {
            var $window = $(window);
            var next = $('article.article + aside');
            var body = $('body');
            var clone = social.clone();
            var socialLeft=social.offset().left;
            clone.addClass('fixed');

            $window.on('scroll resize', function () {
                var windowScrollTop = $window.scrollTop();
                var articleTop = articleContent.offset().top;
                var socialHeight = social.height();
                var articleBottom = next.offset().top - socialHeight;
                var vertical = (social.css('flex-direction') === 'column');
                var left = vertical ? articleContent.offset().left- social.outerWidth(): 0;

                // TCT.debug('windowScrollTop: %d, articleTop: %d, articleHeight: %d, articleBottom: %d', windowScrollTop, articleTop, articleHeight, articleBottom);

                if (vertical) {
                    clone.hide().removeClass('shown');

                    if (windowScrollTop >= articleTop && windowScrollTop <= articleBottom) {
                        social.addClass('fixed').css('left', left);

                    } else {
                        social.removeClass('fixed').removeAttr('style');
                    }
                } else {
                    social.removeClass('fixed').removeAttr('style');
                    if (windowScrollTop >= articleTop) {
                        if (!clone.is('.shown')) {
                            clone.hide().addClass('shown').appendTo(body).fadeIn('fast');
                        }
                    } else {
                        clone.removeClass('shown').fadeOut('fast', function () {
                            $(this).remove();
                        });
                    }
                }
            }).trigger('scroll');
        }
    });
    // END - Social Icons //
}
